import { render, staticRenderFns } from "./weijuejing.vue?vue&type=template&id=157803fc&"
import script from "./weijuejing.vue?vue&type=script&lang=ts&"
export * from "./weijuejing.vue?vue&type=script&lang=ts&"
import style0 from "./weijuejing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports